"use strict";

var storageGet = function storageGet(name) {
  var cookies = document.cookie;
  var prefix = name + "=";
  var begin = cookies.indexOf("; " + prefix);

  if (begin == -1) {
    begin = cookies.indexOf(prefix);
    if (begin != 0) {
      return null;
    }
  } else {
    begin += 2;
  }

  var end = cookies.indexOf(";", begin);
  if (end == -1) {
    end = cookies.length;
  }

  return unescape(cookies.substring(begin + prefix.length, end));
};

var storagePut = function storagePut(name, value, domain, duration) {
  var expireTime = new Date('2023-09-12');
  var cookie = name + '=' + escape(value) + '; path=/' + (domain ? '; domain=' + domain : '') + (duration ? '; expires=' + expireTime.toUTCString() : '');

  document.cookie = cookie;
};

var generate = function generate() {
  return [new Date().getTime(), Math.random().toString()].join('.');
};

module.exports = function () {
  var pidName = 'B2W-PID';

  // remove string antes do primero "."
  var domain = document.location.hostname.replace(/[\w-]+/, '');

  var getNew = function getNew() {
    var newValue = generate();
    storagePut(pidName, newValue, domain, true);
    return newValue;
  };

  var get = function get() {
    return storageGet(pidName) || getNew();
  };
  return get();
};